export const CHAT_PLATFORM = {
  WHATSAPP: 'AMIO_WHATSAPP',
}
